import addHighContrastStyles from 'lib/styling/addHighContrastStyles';

const addBorderInHighContrastMode = addHighContrastStyles(({ theme }) => ({
  border: `2px solid ${theme.palette.divider}`
}));

export default addBorderInHighContrastMode;
